import { scoreRules } from '@internal/backstage-plugin-renovate-stats';

import {
  CustomHealthCard,
  HealthScoreCard,
  SimpleScore,
} from '@internal/ui-common';

interface RenovateScoreCardProps {
  title: string;
  tooltip: string;
  deepLinkTitle: string;
  score: SimpleScore;
  link: string;
}

function RenovateScoreCard({
  tooltip,
  deepLinkTitle,
  score,
  link,
}: Readonly<RenovateScoreCardProps>) {
  return (
    <CustomHealthCard
      title="Renovate"
      tooltip={tooltip}
      deepLink={{ title: deepLinkTitle, link: link }}
    >
      <HealthScoreCard
        score={score}
        scoreRules={scoreRules}
        trendInfo={{ enabled: false }}
      />
    </CustomHealthCard>
  );
}

export { RenovateScoreCard };
